import { render, staticRenderFns } from "./PlantNutrients.vue?vue&type=template&id=731de766&lang=html&"
import script from "./PlantNutrients.vue?vue&type=script&lang=js&"
export * from "./PlantNutrients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PlantNutrients.vue"
export default component.exports